import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import TinySlider from 'tiny-slider-react';
import ProductCard from '../product_card';

export const CrossSell = ({ items, title = '', text = '' }) => {
  const tinySliderSettings = {
    mode: 'carousel',
    navPosition: 'bottom',
    controls: false,
    autoplay: false,
    autoplayButtonOutput: false,
    loop: true,
    items: 1,
    edgePadding: items.length > 1 ? 32 : 0,
    gutter: 16,
    responsive: {
      // Bootstrap small breakpoint
      576: {
        items: 2,
        edgePadding: items.length > 2 ? 32 : 0,
      },
      // Bootstrap medium breakpoint
      768: {
        items: 3,
        edgePadding: items.length > 3 ? 32 : 0,
      },
    },
  };

  const renderItems = () =>
    items.map((item) => (
      <div key={item.id}>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <ProductCard {...item} />
      </div>
    ));

  return (
    <>
      <div className="content mb-6">{parse(`<h2>${title}</h2> ${text}`)}</div>
      <div className="carousel--cards">
        <TinySlider settings={tinySliderSettings}>{renderItems()}</TinySlider>
      </div>
    </>
  );
};

CrossSell.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.array.isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
};

export default CrossSell;
